<template>
  <v-snackbar v-model="showErrorMessage" color="error" multi-line bottom>
    <p class="mb-0" v-html="errorMessage"></p>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ErrorMessage',
  computed: {
    ...mapGetters(['showErrorMessage', 'errorMessage']),
  },
};
</script>
